var lineNumber = 1;
var badgeText = "";
var badgeText2 = "";
var colorName = "Blue";

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function sanitizeText(text) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(text));
    return div.innerHTML;
}

function selectVerticalBadgeBottom() {
  $(".selectedColor").css({width: "129px", "margin-left": "68px", "margin-top": "-121px", height: "86px"});
  $(".selectedBadge").attr("src", "//cdn.shopify.com/s/files/1/1260/4809/files/bbottomvertical.webp?v=1689698730");

  $("#imgHorizontal").css("border", "0px");
  $(".horimg").css("display", "none");
  $("#imgVertical").css("border", "3px solid #F5911F");
  wide = false;
  $(".product_code").text("BADGEBOTTOMS-V");
  productCode = "BADGEBOTTOMS-V";
  fixTextPosition(1);
  resetText();
}

function selectHorizontalBadgeBottom() {
  $(".selectedColor").css({width: "190px", "margin-left": "45px", "margin-top": "-90px", height: "61px"});
  $("#tab1").css({"margin-bottom": "-100px"});
  $(".selectedBadge").attr("src", "//cdn.shopify.com/s/files/1/1260/4809/files/bbottomhorizon.jpg?v=1689699832");

  $(".verimg").css("display", "none");
  $("#imgHorizontal").css("border", "3px solid #F5911F");

  $("#imgVertical").css("border", "0px");
  $(".product_code").text("BADGEBOTTOMS-H");
  productCode = "BADGEBOTTOMS-H";
  wide = true;
  fixTextPosition(1);
  resetText();
}

function selectHorizontalBadgeBuddiesXL() {
  $(".selectedColor").css({width: "183px", "margin-left": "53px", "margin-top": "-83px", height: "61px"});
  $("#tab1").css({"margin-bottom": "-100px"});
  $(".selectedBadge").attr('src', '//cdn.shopify.com/s/files/1/1260/4809/products/BB-1XL-CUSTOM-BLUE-H.png?v=1688152738');

  $(".verimg").css("display", "none");
  $("#imgHorizontal").css("border", "3px solid #F5911F");

  $("#imgVertical").css("border", "0px");
  $(".product_code").text("BADGEBOTTOMS-H-1XL");
  productCode = "BADGEBOTTOMS-H-1XL";
  wide = true;
  fixTextPosition(1);
  resetText();
}

function selectVerticalBadgeBuddiesXL() {
  $(".selectedColor").css({width: "122px", "margin-left": "143px", "margin-top": "-116px", height: "84px"});
  $("#tab1").css({"margin-bottom": "-100px"});
  $(".selectedBadge").attr('src', '//www.specialistid.com/cdn/shop/t/68/assets/BB-1XL-CUSTOM-RED-V_800x800.png?v=136908169347785232851690782186');

  $(".verimg").css("display", "none");
  $("#imgVertical").css("border", "3px solid #F5911F");
  $("#tab2").addClass("vertical-badge-buddies-1xl");

  $("#imgVertical").css("border", "0px");
  $(".product_code").text("BADGEBOTTOMS-H-1XL");
  productCode = "BADGEBOTTOMS-H-1XL";
  wide = true;
  fixTextPosition(1);
  resetText();
}

function selectHorizontalClear() {
  $(".selectedColor").css({width: "244px", "margin-left": "10px", "margin-top": "-226px", height: "88px"});

  $(".selectedBadge").attr("src", "//cdn.shopify.com/s/files/1/1260/4809/files/bbhorizontal.webp?v=1689698297");
  $(".selectedBadge").css({"pointer-events": "none"});
  $(".textHolder").css({"pointer-events": "auto"});

  $("#imgHorizontal").css("border", "3px solid #F5911F");
  $("#imgVertical").css("border", "0px");
  $(".product_code").text("BB-CUSTOM-COLOR-H");
  $("#tab2").addClass("badge-buddies-clear-horizontal");
  productCode = "BB-CUSTOM-COLOR-H";
  wide = true;
  fixTextPosition(1);
  resetText();
}

function selectVerticalClear() {
  $(".selectedColor").css({width: "146px", "margin-left": "60px", "margin-top": "-136px", height: "95px"});

  $(".selectedBadge").attr("src", "//cdn.shopify.com/s/files/1/1260/4809/files/bbvertical.webp?v=1689698740");
  $("#imgHorizontal").css("border", "0px");
  $("#imgVertical").css("border", "3px solid #F5911F");
  wide = false;
  $(".product_code").text("BB-CUSTOM-COLOR-V");
  $("#tab2").addClass("badge-buddies-clear-vertical");
  productCode = "BB-CUSTOM-COLOR-V";
  fixTextPosition(1);
  resetText();
}

function selectHorizontal() {
  $(".selectedColor").css({width: "225px", "margin-left": "20px", "margin-top": "-226px", height: "78px"});

  $(".selectedBadge").attr("src", "//cdn.shopify.com/s/files/1/1260/4809/files/bbhorizontal.webp?v=1689698297");
  $(".selectedBadge").css({"pointer-events": "none"});
  $(".textHolder").css({"pointer-events": "auto"});

  $("#imgHorizontal").css("border", "3px solid #F5911F");
  $("#imgVertical").css("border", "0px");
  $(".product_code").text("BB-CUSTOM-COLOR-H");
  productCode = "BB-CUSTOM-COLOR-H";
  wide = true;
  fixTextPosition(1);
  resetText();
}

function selectVertical() {
  $(".selectedColor").css({width: "129px", "margin-left": "70px", "margin-top": "-136px", height: "86px"});

  $(".selectedBadge").attr("src", "//cdn.shopify.com/s/files/1/1260/4809/files/bbvertical.webp?v=1689698740");
  $("#imgHorizontal").css("border", "0px");
  $("#imgVertical").css("border", "3px solid #F5911F");
  wide = false;
  $(".product_code").text("BB-CUSTOM-COLOR-V");
  productCode = "BB-CUSTOM-COLOR-V";
  fixTextPosition(1);
  resetText();
}

function resetApp() {
  $("#inputQuntity").val("6");

  var custom_bb_type = $(".custom_bb_type").val();

  switch (custom_bb_type) {
    case 'Badge Buddy - Horizontal':
      selectHorizontal();
      break;
    case 'Badge Buddy - Vertical':
      selectVertical();
      break;
    case 'Badge Buddy Clear - Horizontal':
      selectHorizontalClear();
      break;
    case 'Badge Buddy Clear - Vertical':
      selectVerticalClear();
      break;
    case 'Badge Buddy - XL - Horizontal':
      selectHorizontalBadgeBuddiesXL();
      break;
    case 'Badge Buddy - XL - Vertical':
      selectVerticalBadgeBuddiesXL();
      break;
    case 'Badge Bottoms - Horizontal':
      selectHorizontalBadgeBottom();
      break;
    case 'Badge Bottoms - Vertical':
      selectVerticalBadgeBottom();
      break;
  }

  resetText();
}

function resetText(){
    $("#inputText1").val("");
    $("#badgeOneLine").val("");

    $("#inputText2").val("");
    $("#badgeSecondLine").val("");

    setBadgeText('');
    setBadgeText('',true);
}

function fixTextPosition(tab){
	if(wide){
		$('#badge-preview-text').attr( "class", "badge-preview-text-tab"+tab +"w");
	}else{
		$('#badge-preview-text').attr( "class", "badge-preview-text-tab"+tab );
	}

	if(lineNumber==2){
		$('#badge-preview-text').attr( "class", $('#badge-preview-text').attr( "class") + "line2");
	}
}

function setBadgeText(txt, secondLine) {
    if (secondLine) {
        badgeText2 = txt;
    } else {
        badgeText = txt;
    }

    // Determine line count based on whether line 2 actually has content
    var line2Val = $(".custom-line-2 input[type=text]").val() || "";
    var hasSecondLine = (badgeText2 && badgeText2 !== "") || (line2Val !== "");
	if(hasSecondLine){
		lineNumber = 2;
	}else{
		lineNumber = 1;
	}
    if(badgeText == undefined){
    	badgeText = "";
    }

    if(badgeText2 == undefined){
    	badgeText2 = "";
    }

    var html;

    if (lineNumber == 2 && secondLine) {
    	html = '<div id="txtSpan1" style="width:100%;"><span id="doubleSpan1" style="display:inline-block">' + badgeText + '</span></div>';
    	html += '<div id="txtSpan2" style="width:100%;"><span id="doubleSpan2" style="display:inline-block">' + txt + '</span></div>';
    } else if (lineNumber == 2) {
    	html = '<div id="txtSpan1" style="width:100%;"><span id="doubleSpan1" style="display:inline-block">' + txt+'</span></div>';
        html += '<div id="txtSpan2" style="width:100%;"><span id="doubleSpan2" style="display:inline-block">'+ badgeText2 + '</span></div>';
    } else {
        html = "<div id='txtSingle' style='width:100%;'><span id='singleSpan' style='display:inline-block'>" + badgeText + '</span></div>';
    }

    $("#badge-preview-text").html(html);

    if ($.fn.textfill) {
      $("#txtSpan1").textfill({
          widthOnly: true,
          maxFontPixels:40
      });

      $("#txtSpan2").textfill({
          widthOnly: true,
          maxFontPixels:40
      });

      $("#txtSingle").textfill({
          widthOnly: true,
          maxFontPixels:60
      });
    }

    // Match line-height to font-size (ratio 0.733 based on minion-pro: 44px line-height at 60px font-size)
    var lhRatio = 0.733;

    if(lineNumber == 1){
        var singleSize = parseFloat($("#singleSpan").css("font-size")) || 0;
        if(singleSize > 0){
            $("#singleSpan").css("line-height", Math.ceil(singleSize * lhRatio) + "px");
        }
    }

    if(lineNumber == 2){
        var size1 = parseFloat($("#doubleSpan1").css("font-size")) || 0;
        var size2 = parseFloat($("#doubleSpan2").css("font-size")) || 0;

        // Equalize font sizes between the two lines for consistent look
        if(size1 > 0 && size2 > 0){
            var minSize = Math.min(size1, size2);
            $("#doubleSpan1").css("font-size", minSize + "px");
            $("#doubleSpan2").css("font-size", minSize + "px");
            size1 = minSize;
            size2 = minSize;
        }

        if(size1 > 0){
            $("#doubleSpan1").css("line-height", Math.ceil(size1 * lhRatio) + "px");
        }
        if(size2 > 0){
            $("#doubleSpan2").css("line-height", Math.ceil(size2 * lhRatio) + "px");
        }
    }

    // Add bottom margin when descender characters are present (proportional to font size)
    var descenderRatio = 0.2;
    if(lineNumber == 1){
        var singleFontSize = parseFloat($("#singleSpan").css("font-size")) || 0;
        $("#singleSpan").css("margin-bottom", checkForDescenders(badgeText) ? Math.ceil(singleFontSize * descenderRatio) + "px" : "0px");
    }
    if(lineNumber == 2){
        var font1 = parseFloat($("#doubleSpan1").css("font-size")) || 0;
        var font2 = parseFloat($("#doubleSpan2").css("font-size")) || 0;
        $("#doubleSpan1").css("margin-bottom", checkForDescenders(badgeText) ? Math.ceil(font1 * descenderRatio) + "px" : "0px");
        $("#doubleSpan2").css("margin-bottom", checkForDescenders(badgeText2) ? Math.ceil(font2 * descenderRatio) + "px" : "0px");
    }
}

function checkForDescenders(text) {
    if (!text) return false;
    return /[qypgj]/.test(text);
}

function cleanStyleValue(value){
	return Number(parseFloat(value));
}

function replaceKey(value){
    if (!value) return value;
    return sanitizeText(value);
}

function changeColor(color) {
    if (!color) return;

    var $productContainer = $(".product").first();
    if ($productContainer.length === 0) {
        $productContainer = $("body");
    }

    $productContainer.removeClass(function (index, className) {
        return (className.match (/(^|\s)product-variant-color-\S+/g) || []).join(' ');
    });

    var colorClass = 'product-variant-color-' + color.replace(/\s+/g, '-').toLowerCase();
    $productContainer.addClass(colorClass);
}

$(document).ready(function() {
    resetApp();

    // Detect initial color selection
    var startColor = null;
    $("input[type='radio']:checked").each(function() {
        var inputName = $(this).attr('name');
        if (inputName && inputName.toLowerCase().indexOf('color') !== -1) {
            startColor = $(this).val();
            return false;
        }
    });

    if (startColor) {
        changeColor(startColor);
    } else {
        $("input[type='radio']").each(function() {
            var inputName = $(this).attr('name');
            if (inputName && inputName.toLowerCase().indexOf('color') !== -1) {
                startColor = $(this).val();
                changeColor(startColor);
                return false;
            }
        });
    }

    // Text input listeners
    $('#infiniteoptions-container').on('input', '.custom-line-1 input[type=text]', function() {
        setBadgeText(replaceKey($(this).val()));
        $("#bb_option_custom_line_1").val($(this).val());
    });

    $('#infiniteoptions-container').on('input', '.custom-line-2 input[type=text]', function() {
        setBadgeText(replaceKey($(this).val()), true);
        $("#bb_option_custom_line_2").val($(this).val());
    });

    // Single color change listener that handles all color-related radio inputs
    $(document).on('change', 'input[type="radio"]', function() {
        var inputName = $(this).attr('name');
        if (inputName && inputName.toLowerCase().indexOf('color') !== -1) {
            changeColor($(this).val());
        }
    });

    // Pre-fill from ?line1=/?line2= once the Infinite Options fields exist, then stop.
    // The observer used to stay connected and re-fill Line 1 whenever it was empty, so
    // a shopper could never clear it (SPID-334, Shopper Approved review, order 1175598).
    var target = $('#infiniteoptions-container')[0];
    var urlLine1 = getParameterByName('line1');
    var urlLine2 = getParameterByName('line2');

    if (target && (urlLine1 || urlLine2)) {
        var prefilled = false;
        var prefill = function() {
            var $l1 = $('.custom-line-1 input[type=text]');
            if (prefilled || !$l1.length) return false; // inputs not rendered yet
            prefilled = true;

            if (urlLine1) {
                $('input[name="properties[Custom Line 1]"]').val(urlLine1);
                setBadgeText(replaceKey(urlLine1));
                $("#bb_option_custom_line_1").val(urlLine1);
            }

            if (urlLine2) {
                $('input[name="properties[Custom Line 2]"]').val(urlLine2);
                setBadgeText(replaceKey(urlLine2), true);
                $("#bb_option_custom_line_2").val(urlLine2);
            }
            return true;
        };

        if (!prefill()) {
            var observer = new MutationObserver(function() {
                if (prefill()) observer.disconnect();
            });
            observer.observe(target, { childList: true, subtree: true });
        }
    }
});